import type { Order } from "../../../../../../../services";

const cellProcessing = (
	item: Order.Model["orderToServices"],
	language: string,
): string =>
	item
		?.map((orderToService) => orderToService?.service?.name?.[language])
		?.filter(Boolean)
		?.join(", ") ?? "";

export default cellProcessing;
